var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapV2MiddleShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 1001,
    viewBox: "0 0 21 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 56H0V63H7V56Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 56H14V63H21V56Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 42H0V49H7V42Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49H7V56H14V49Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42H14V49H21V42Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28H0V35H7V28Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 35H7V42H14V35Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H14V35H21V28Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H0V21H7V14Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H7V28H14V21Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7 98H0V105H7V98Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 98H14V105H21V98Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7 84H0V91H7V84Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14 91H7V98H14V91Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21 84H14V91H21V84Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7 70H0V77H7V70Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77H7V84H14V77Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21 70H14V77H21V70Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14 63H7V70H14V63Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7 140H0V147H7V140Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21 140H14V147H21V140Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7 126H0V133H7V126Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14 133H7V140H14V133Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21 126H14V133H21V126Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7 112H0V119H7V112Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14 119H7V126H14V119Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21 112H14V119H21V112Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14 105H7V112H14V105Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7 182H0V189H7V182Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21 182H14V189H21V182Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7 168H0V175H7V168Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14 175H7V182H14V175Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21 168H14V175H21V168Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7 154H0V161H7V154Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14 161H7V168H14V161Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21 154H14V161H21V154Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14 147H7V154H14V147Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7 224H0V231H7V224Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21 224H14V231H21V224Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7 210H0V217H7V210Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14 217H7V224H14V217Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21 210H14V217H21V210Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7 196H0V203H7V196Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14 203H7V210H14V203Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21 196H14V203H21V196Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14 189H7V196H14V189Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7 266H0V273H7V266Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21 266H14V273H21V266Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7 252H0V259H7V252Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14 259H7V266H14V259Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21 252H14V259H21V252Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7 238H0V245H7V238Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14 245H7V252H14V245Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21 238H14V245H21V238Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14 231H7V238H14V231Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7 308H0V315H7V308Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21 308H14V315H21V308Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7 294H0V301H7V294Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14 301H7V308H14V301Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21 294H14V301H21V294Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7 280H0V287H7V280Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M14 287H7V294H14V287Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21 280H14V287H21V280Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14 273H7V280H14V273Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7 350H0V357H7V350Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21 350H14V357H21V350Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7 336H0V343H7V336Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14 343H7V350H14V343Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21 336H14V343H21V336Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7 322H0V329H7V322Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14 329H7V336H14V329Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21 322H14V329H21V322Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14 315H7V322H14V315Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M7 392H0V399H7V392Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21 392H14V399H21V392Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M7 378H0V385H7V378Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14 385H7V392H14V385Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21 378H14V385H21V378Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7 364H0V371H7V364Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14 371H7V378H14V371Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M21 364H14V371H21V364Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14 357H7V364H14V357Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M7 434H0V441H7V434Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21 434H14V441H21V434Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M7 420H0V427H7V420Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M14 427H7V434H14V427Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21 420H14V427H21V420Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M7 406H0V413H7V406Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M14 413H7V420H14V413Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21 406H14V413H21V406Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M14 399H7V406H14V399Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7 476H0V483H7V476Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21 476H14V483H21V476Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M7 462H0V469H7V462Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14 469H7V476H14V469Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21 462H14V469H21V462Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7 448H0V455H7V448Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14 455H7V462H14V455Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21 448H14V455H21V448Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14 441H7V448H14V441Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M7 518H0V525H7V518Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21 518H14V525H21V518Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M7 504H0V511H7V504Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14 511H7V518H14V511Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M21 504H14V511H21V504Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M7 490H0V497H7V490Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M14 497H7V504H14V497Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M21 490H14V497H21V490Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14 483H7V490H14V483Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7 560H0V567H7V560Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M21 560H14V567H21V560Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7 546H0V553H7V546Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M14 553H7V560H14V553Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M21 546H14V553H21V546Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M7 532H0V539H7V532Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M14 539H7V546H14V539Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21 532H14V539H21V532Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M14 525H7V532H14V525Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7 602H0V609H7V602Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M21 602H14V609H21V602Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7 588H0V595H7V588Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M14 595H7V602H14V595Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M21 588H14V595H21V588Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7 574H0V581H7V574Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14 581H7V588H14V581Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21 574H14V581H21V574Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14 567H7V574H14V567Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7 644H0V651H7V644Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M21 644H14V651H21V644Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M7 630H0V637H7V630Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14 637H7V644H14V637Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21 630H14V637H21V630Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7 616H0V623H7V616Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 623H7V630H14V623Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M21 616H14V623H21V616Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14 609H7V616H14V609Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M7 686H0V693H7V686Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M21 686H14V693H21V686Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M7 672H0V679H7V672Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M14 679H7V686H14V679Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21 672H14V679H21V672Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M7 658H0V665H7V658Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M14 665H7V672H14V665Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21 658H14V665H21V658Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14 651H7V658H14V651Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7 728H0V735H7V728Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M21 728H14V735H21V728Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M7 714H0V721H7V714Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M14 721H7V728H14V721Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M21 714H14V721H21V714Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M7 700H0V707H7V700Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14 707H7V714H14V707Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M21 700H14V707H21V700Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14 693H7V700H14V693Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7 770H0V777H7V770Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21 770H14V777H21V770Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7 756H0V763H7V756Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M14 763H7V770H14V763Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21 756H14V763H21V756Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7 742H0V749H7V742Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M14 749H7V756H14V749Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M21 742H14V749H21V742Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14 735H7V742H14V735Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M7 812H0V819H7V812Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M21 812H14V819H21V812Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M7 798H0V805H7V798Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M14 805H7V812H14V805Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M21 798H14V805H21V798Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7 784H0V791H7V784Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M14 791H7V798H14V791Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M21 784H14V791H21V784Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M14 777H7V784H14V777Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M7 840H0V847H7V840Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M21 840H14V847H21V840Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M7 826H0V833H7V826Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M14 833H7V840H14V833Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21 826H14V833H21V826Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M14 819H7V826H14V819Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14H14V21H21V14Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H0V7H7V0Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H7V14H14V7Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H14V7H21V0Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7 854H0V861H7V854Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M21 854H14V861H21V854Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M14 847H7V854H14V847Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M7 868H0V875H7V868Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M7 882H0V889H7V882Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7 896H0V903H7V896Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M7 910H0V917H7V910Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7 924H0V931H7V924Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7 938H0V945H7V938Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7 952H0V959H7V952Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7 966H0V973H7V966Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M7 980H0V987H7V980Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M7 994H0V1001H7V994Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M21 868H14V875H21V868Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21 882H14V889H21V882Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M21 896H14V903H21V896Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21 910H14V917H21V910Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M21 924H14V931H21V924Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M21 938H14V945H21V938Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M21 952H14V959H21V952Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21 966H14V973H21V966Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M21 980H14V987H21V980Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M21 994H14V1001H21V994Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M14 861H7V868H14V861Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M14 875H7V882H14V875Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M14 889H7V896H14V889Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M14 903H7V910H14V903Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14 917H7V924H14V917Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M14 931H7V938H14V931Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M14 945H7V952H14V945Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M14 959H7V966H14V959Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14 973H7V980H14V973Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M14 987H7V994H14V987Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapV2MiddleShape);
export default __webpack_public_path__ + "static/media/roadmap_v2_middle_shape.711e4a67b0af638573101a1e7547f044.svg";
export { ForwardRef as ReactComponent };